import React from "react";

const About = () => (
  <section className="p-3 md:p-8 max-w-5xl mx-auto space-y-5 md:space-y-6">
    <div className="text-3xl md:text-4xl font-bold text-white border-b-2 border-borderPrimary pb-2">
      About Me
    </div>
    <p className="text-base md:text-lg text-textSecondary leading-relaxed">
      Hey, I’m Chris Barry. I build cool stuff for the web, break it, then build
      it better. I’m all about clean code, seamless user experiences, and
      figuring out how to make things work smoother and faster. I’ve spent a
      good chunk of my time diving deep into frontend interfaces and backend
      logic, turning ideas into solid, scalable applications. Outside of work,
      you’ll probably find me experimenting with game development, tweaking side
      projects, or playing video games with my kids.
    </p>
  </section>
);

export default About;
